import { useCallback } from "react";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { useCheckoutFastFlowContext } from "@checkout-v2/features/checkoutFastFlow";

type UseGtmCtaClickPaymentReturn = {
  trackGtmCtaClickPayment: () => void;
};

export const useGtmCtaClickPayment = (): UseGtmCtaClickPaymentReturn => {
  const { checkoutFlowType } = useCheckoutFastFlowContext();

  const trackGtmCtaClickPayment = useCallback(() => {
    if (!checkoutFlowType) {
      return;
    }

    dispatchTrackingEvent(TrackingEvents.TrackingCheckoutOrderPaymentCtaClick, {
      cta_name: "payment",
      cta_location: "checkout",
      checkout_flow_type: checkoutFlowType,
    });
  }, [checkoutFlowType]);

  return { trackGtmCtaClickPayment };
};
